import { post , get,request} from './http.js';

export function queryBase(headers){
  return post(headers,"/api/consumer/appendInfo/queryBase");
}

export function appendBase(headers,data){
  return post(headers,"/api/consumer/appendInfo/appendBase",data);
}

export function appendCourse(headers,data){
  return post(headers,"/api/consumer/appendInfo/appendCourse",data);
}

export function appendContest(headers,data){
  return post(headers,"/api/consumer/appendInfo/appendContest",data);
}

export function appendThesis(headers,data){
  return post(headers,"/api/consumer/appendInfo/appendThesis",data);
}

export function complete(headers){
  return post(headers,"/api/consumer/appendInfo/complete");
}
export function formPreview(data){
  return request("/formCustomer/form",data);
}
export function submit(data){
  return request("/formCustomer/submit",data);
}


export function investigationInfo(headers,data){
  return get(headers,"/consumer/investigationInfo",data);
}

export function investigationSubmit(headers,data){
  return post(headers,"consumer/investigationSubmit",data);
}


// WEBPACK FOOTER //
// ./src/request/main.js